(function () {
  const OPPREF_PARAM = 'oppref';
  const STORAGE_KEY = 'saludi_openai_oppref';
  const CART_SYNC_KEY = 'saludi_openai_oppref_synced';
  const LEAD_EVENT_KEY = 'saludi_openai_lead_created';
  const OPPREF_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  const ATTRIBUTION_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term'
  ];

  function getSearchParams() {
    try {
      return new URLSearchParams(window.location.search);
    } catch (error) {
      return new URLSearchParams();
    }
  }

  function safeStorage(type) {
    try {
      return window[type];
    } catch (error) {
      return null;
    }
  }

  function publishCustomerEvent(name, data) {
    if (!window.Shopify?.analytics || typeof window.Shopify.analytics.publish !== 'function') {
      return false;
    }
    window.Shopify.analytics.publish(name, data || {});
    return true;
  }

  function marketingAllowed() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function') return false;
    return privacy.marketingAllowed();
  }

  function emptyAttribution() {
    return {
      oppref: '',
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
      utm_content: '',
      utm_term: ''
    };
  }

  function normalizeParam(value) {
    return String(value || '').replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, 255);
  }

  function readStoredAttribution(storage) {
    if (!storage) return emptyAttribution();
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) return emptyAttribution();
    try {
      const record = JSON.parse(raw);
      if (!record.value || !record.capturedAt || Date.now() - record.capturedAt > OPPREF_TTL_MS) {
        storage.removeItem(STORAGE_KEY);
        storage.removeItem(CART_SYNC_KEY);
        return emptyAttribution();
      }
      const attribution = {
        ...emptyAttribution(),
        ...(record.attribution || {})
      };
      attribution.oppref = normalizeParam(
        record.attribution ? record.attribution.oppref : record.value
      );
      return attribution;
    } catch (error) {
      storage.removeItem(STORAGE_KEY);
      storage.removeItem(CART_SYNC_KEY);
      return emptyAttribution();
    }
  }

  function captureAttribution() {
    const params = getSearchParams();
    const oppref = normalizeParam(params.get(OPPREF_PARAM));
    const source = normalizeParam(params.get('utm_source')).toLowerCase();
    const storage = safeStorage('localStorage');

    if (!storage) return emptyAttribution();
    if (!oppref && source !== 'openai') return readStoredAttribution(storage);

    const attribution = emptyAttribution();
    attribution.oppref = oppref;
    ATTRIBUTION_PARAMS.forEach((name) => {
      attribution[name] = normalizeParam(params.get(name));
    });

    // A new OpenAI click starts a new 30-day attribution window.
    storage.setItem(STORAGE_KEY, JSON.stringify({
      value: oppref || source,
      attribution,
      capturedAt: Date.now()
    }));
    storage.removeItem(CART_SYNC_KEY);
    return attribution;
  }

  function cartAttributes(attribution) {
    const attributes = {
      openai_oppref: attribution.oppref || '',
      openai_ads_marketing_consent: 'true'
    };
    ATTRIBUTION_PARAMS.forEach((name) => {
      attributes[`openai_${name}`] = attribution[name] || '';
    });
    return attributes;
  }

  function syncAttributionToCart(attribution) {
    const storage = safeStorage('localStorage');
    const cartUpdateUrl = window.routes?.cart_update_url || '/cart/update.js';
    const attributes = cartAttributes(attribution);
    const hasOpenAIAttribution = Boolean(attribution.oppref) ||
      attribution.utm_source.toLowerCase() === 'openai';
    if (!hasOpenAIAttribution || !storage || !marketingAllowed()) return;

    fetch(window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js', {
      headers: { Accept: 'application/json' }
    }).then((response) => response.ok ? response.json() : null).then((cart) => {
      const alreadySynced = Object.entries(attributes).every(([key, value]) =>
        String(cart?.attributes?.[key] || '') === value
      );
      if (alreadySynced) {
        storage.setItem(CART_SYNC_KEY, JSON.stringify(attributes));
        return null;
      }
      return fetch(cartUpdateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes
        }),
        keepalive: true
      });
    }).then((response) => {
      if (!response) return;
      if (response.ok) storage.setItem(CART_SYNC_KEY, JSON.stringify(attributes));
    }).catch(() => {});
  }

  function publishFormSuccessLeads() {
    const params = getSearchParams();
    const session = safeStorage('sessionStorage');
    if (session?.getItem(LEAD_EVENT_KEY)) return;
    let published = false;
    if (params.get('customer_posted') === 'true') {
      published = publishCustomerEvent('openai_lead_created', {
        lead_type: 'newsletter',
        source_url: window.location.href
      });
    }
    if (params.get('contact_posted') === 'true') {
      published = publishCustomerEvent('openai_lead_created', {
        lead_type: 'contact_form',
        source_url: window.location.href
      });
    }
    if (published) session?.setItem(LEAD_EVENT_KEY, '1');
  }

  function normalizeText(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function handleOutboundClick(event) {
    const link = event.target.closest?.('a[href]');
    if (!link || !/amazon\./i.test(link.hostname || link.href)) return;
    publishCustomerEvent('openai_amazon_outbound_clicked', {
      href: link.href,
      link_text: normalizeText(link.textContent),
      source_url: window.location.href
    });
  }

  if (marketingAllowed()) {
    syncAttributionToCart(captureAttribution());
  }
  publishFormSuccessLeads();
  document.addEventListener('click', handleOutboundClick, true);
  document.addEventListener('visitorConsentCollected', () => {
    if (marketingAllowed()) syncAttributionToCart(captureAttribution());
  });
})();
